document.addEventListener('click', event => {
  const close = event.target.closest('[data-qz-close-menu]');
  if (close) { const menu=close.closest('.qz-mobile-navigation');menu.open=false;menu.querySelector('summary').focus(); }
  const openMenu=document.querySelector('.qz-mobile-navigation[open]');
  if(openMenu && !openMenu.contains(event.target)){openMenu.open=false;}
});
document.addEventListener('keydown', event => {
  if(event.key==='Escape'){document.querySelectorAll('.qz-nav-dropdown[open],.qz-mobile-navigation[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}
});
document.querySelectorAll('.qz-nav-dropdown').forEach(menu=>menu.addEventListener('toggle',()=>{if(menu.open){document.querySelectorAll('.qz-nav-dropdown').forEach(other=>{if(other!==menu)other.open=false;});}}));
const mobileMenu=document.querySelector('.qz-mobile-navigation');
mobileMenu?.addEventListener('toggle',()=>{document.documentElement.classList.toggle('qz-menu-open',mobileMenu.open);if(mobileMenu.open)mobileMenu.querySelector('[data-qz-close-menu]').focus();});
document.addEventListener('keydown',event=>{
  if(event.key!=='Tab'||!mobileMenu?.open)return;
  const stops=Array.from(mobileMenu.querySelector('.qz-mobile-navigation-panel').querySelectorAll('button,a[href],summary')).filter(el=>el.getClientRects().length>0);
  const first=stops[0],last=stops[stops.length-1];
  if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
  else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
});

